import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e4a00116&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4a00116",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\xingxingzu\\multi_merchant_web\\supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e4a00116')) {
      api.createRecord('e4a00116', component.options)
    } else {
      api.reload('e4a00116', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=e4a00116&scoped=true&", function () {
      api.rerender('e4a00116', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/info/source/index.vue"
export default component.exports